exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".deja-nav-bar {\n  height: 48px;\n  background: #ffffff;\n  border: 1px solid #D6D6D6;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n.deja-nav-bar .nav-bar {\n  display: flex;\n  justify-content: center;\n}\n.deja-nav-bar .nav-bar li {\n  padding: 0 16px;\n  list-style: none;\n  margin-right: 40px;\n}\n.deja-nav-bar .nav-bar li:last-child {\n  margin-right: 0;\n}\n.deja-nav-bar .nav-bar li a {\n  text-decoration: none;\n  font-size: 14px;\n  color: #262729;\n  letter-spacing: 0;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/features/layout/home.less
// module id = 1280
// module chunks = 0